import React, { useState } from 'react';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';

import { RichText, InnerBlocks } from '../assets/components';

const SliderButton = ({ ...rest }) => {
  const { sliderButtonIconClasses } = rest;

  return <i className={sliderButtonIconClasses} />;
};

export function ReadMore({ data, ...rest }) {
  const { attributes, innerBlocks } = data;
  const [opened, setOpened] = useState(false);

  const {
    className,
    tagName: Tag,
    blockClass,
    sliderTextOpened,
    sliderTextClosed,
    buttonClassOpened,
    buttonClassClosed,
  } = attributes;

  const blockClasses = classnames(blockClass, className, {});

  const innerWrapClasses = classnames('dock', {
    'dock-opening-enter-done': opened,
  });

  const sliderClasses = classnames('kubernetes', {
    'dock-opened': opened,
  });

  const sliderTextClasses = classnames('kubernetes__text');

  const sliderButtonIconClasses = classnames('kubernetes__button', 'inverted', {
    [buttonClassClosed]: !opened,
    [buttonClassOpened]: opened,
  });

  const switchState = () => setOpened(!opened);

  return (
    <>
      <Tag className={blockClasses}>
        <CSSTransition in={opened} timeout={500} classNames="dock-opening">
          <div className={innerWrapClasses}>
            <InnerBlocks blocks={innerBlocks} nowrap />
          </div>
        </CSSTransition>

        <div className={sliderClasses} onClick={switchState}>
          <RichText
            className={sliderTextClasses}
            tagName="h6"
            value={opened ? sliderTextOpened : sliderTextClosed}
          />

          <SliderButton sliderButtonIconClasses={sliderButtonIconClasses} />
        </div>
      </Tag>
    </>
  );
}
